import { Component, ElementRef, OnDestroy } from "@angular/core"

@Component({
    template: ` <app-bento-page
        class="w-100 position-relative"
        [bentoLink]="link"
        [componentClasses]="'gtm-our-mission'"
    >
    </app-bento-page>`,
})
export class OurMissionComponent implements OnDestroy {
    link: string = "https://pbs-education-utils.bento-live.pbs.org/about/about-our-mission/"
    constructor(private elementRef: ElementRef) {}

    ngOnDestroy() {
        this.elementRef.nativeElement.remove()
    }
}
